<script lang="ts">
	import LeftCondensed from '@icons/LeftCondensed.svelte';
	import Button from './Button.svelte';
	import Icon from './Icon.svelte';

	export let noLabel = false;
</script>

<div
	class="font-bold text-copy text-center content-module-padding rounded-3xl px-4.5 py-6 my-12"
	class:bg-white={!noLabel}
>
	{#if !noLabel}
		<p class="mb-3">Doch nicht das Richtige?</p>
	{/if}

	<Button tag="a" href="/" class="flex gap-3" trackingLabel="Zurück zur Übersicht">
		<Icon component={LeftCondensed} />
		Zurück zur Übersicht
	</Button>
</div>
